import { render, staticRenderFns } from "./LayoutBlank2.vue?vue&type=template&id=60308452&scoped=true&"
import script from "./LayoutBlank2.vue?vue&type=script&lang=js&"
export * from "./LayoutBlank2.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBlank2.vue?vue&type=style&index=0&id=60308452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60308452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VMain,VRow})
